//#region redux
//#endregion
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { InvoiceFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { FormFieldConstants } from "utils/constants";
import { ObjectSchema } from "models/utilTypes/yupSchemaTypes";
//#endregion
//#region components
import useInvoiceFormValidations from "./create/useInvoiceFormValidations";
import useInvoiceInitialValues from "./create/useInvoiceInitialValues";
import useGetPreviewDefaults from "./preview/usePreviewDefaults";
import useLastSavedMailOptions from "./sendMailOptions/useLastSendMailOptions";
//#endregion
import * as Yup from "yup";

function useInvoiceTodoFormHelpers(invoice: WintSuperkollAPIModel.Invoice) {
  const { getInvoiceInitialValues } = useInvoiceInitialValues(invoice);

  const invoiceInitialValues = getInvoiceInitialValues();
  const { getInitialSendType } = useGetPreviewDefaults();
  const { updateSendMailOptionsFromLastSaved } = useLastSavedMailOptions();

  const initialValues: InvoiceFormTypes.Todo = {
    useToday: false,
    notes: invoiceInitialValues.otherSettings.notes,
    attachments: invoiceInitialValues.otherSettings.attachments,
    ...invoiceInitialValues,
    sendType: getInitialSendType({ creditedInvoiceId: invoice.creditedInvoiceId }, invoice),
    sendMail: invoice.invoiceSendInfo ? updateSendMailOptionsFromLastSaved({}, invoice.invoiceSendInfo) : undefined,
  };

  const { getInvoiceValidationProperties, getValidationSchemaSendEmail } = useInvoiceFormValidations();

  const getValidationSchema = (isFinalApproval?: boolean) =>
    Yup.object<InvoiceFormTypes.Todo>({
      useToday: Yup.boolean(),
      sendType: isFinalApproval ? Yup.number().required(TranslationKeys.Validations.Required) : Yup.number(),
      sendMail: Yup.object<InvoiceFormTypes.SendMail>().when(
        FormFieldConstants.Invoice.Todo.SendType,
        ([sendType], schema: ObjectSchema<InvoiceFormTypes.SendMail>) =>
          sendType === WintSuperkollAPIModel.InvoiceSendMethod.Email
            ? isFinalApproval
              ? Yup.object<InvoiceFormTypes.SendMail>(getValidationSchemaSendEmail(false))
              : Yup.object<InvoiceFormTypes.SendMail>(getValidationSchemaSendEmail(true))
            : schema
      ),
      ...getInvoiceValidationProperties(
        false,
        false,
        false,
        invoice?.totalReminderCost !== undefined && invoice.totalReminderCost < 0,
        invoice?.creditedInvoiceId !== undefined
      ),
    });

  return {
    getValidationSchema,
    initialValues,
  };
}

export default useInvoiceTodoFormHelpers;
